import { mapActions, mapGetters } from 'vuex'

import Design from './Design'
import { SystemLogo } from '@/components/items'
import { UserList, UserInfo, CompanyInfo } from '@/components/layouts/Dialogs'
import { Notice } from '@/components/layouts'
import { OFTEN_SCREEN_INFO } from '@/config/master/screenId'

export default {
  components: {
    Design,
    UserList,
    UserInfo,
    CompanyInfo,
    SystemLogo,
    Notice
  },
  data: () => ({
    navigationMenu: false,
    showRecentActivities: false,
    settting: {
      selected: undefined,
      data: {
        myProfile: { dialog: false },
        company: { dialog: false },
        userList: { dialog: false }
      }
    },
    notice: {
      drawer: null
    }
  }),
  computed: {
    ...mapGetters('User', ['authority']),
    settingList() {
      const myProfile = {
        text: 'common.input_personal-info-setting',
        name: 'myProfile',
        icon: require('@/assets/icon_account.svg')
      }
      const company = {
        text: 'common.input_company-info-setting',
        name: 'company',
        icon: require('@/assets/icon_organization.svg')
      }
      const userList = {
        text: 'common.input_member-management',
        name: 'userList',
        icon: require('@/assets/icon_member.svg')
      }
      const contact = {
        text: 'common.input_inquiry',
        name: 'contact',
        icon: require('@/assets/icon_contact.svg')
      }
      const tutorial = {
        text: 'common.input_tutorial',
        name: 'tutorial',
        icon: require('@/assets/icon_tutorial.svg')
      }

      if (this.authority?.isAdmin) {
        return [
          { ...myProfile },
          { ...company },
          { ...userList },
          { ...contact },
          { ...tutorial }
        ]
      }
      return [{ ...myProfile }, { ...contact }, { ...tutorial }]
    },
    currentOftenUseScreenList() {
      const oftenUseScreenList = this.getOftenUseScreenListFromState()
      const currentOftenUseScreenIds =
        this.getCurrentOftenUseScreenIdsFromState()
      const currentOftenUseScreenList = oftenUseScreenList
        .filter((item) => {
          return currentOftenUseScreenIds.includes(item.oftenUseScreenId)
        })
        .map((item) => {
          return {
            oftenUseScreenId: item.oftenUseScreenId,
            name: OFTEN_SCREEN_INFO[item.oftenUseScreenId].name,
            link: OFTEN_SCREEN_INFO[item.oftenUseScreenId]?.link || 'dashboard'
          }
        })
      return currentOftenUseScreenList
    },
    unreadNoticeCount() {
      const unreadNoticeCount = this.getUnreadNoticeCount()
      return unreadNoticeCount > 99 ? '+99' : String(unreadNoticeCount)
    },
    hasUnreadNotice() {
      const unreadNoticeCount = this.getUnreadNoticeCount()
      return unreadNoticeCount > 0
    }
  },
  methods: {
    ...mapActions('Auth', ['logout']),
    ...mapActions('Common', [
      'setHasDisplayedAlertFlg',
      'getOftenUseScreenListFromApi'
    ]),
    ...mapActions('OftenUse', ['getOftenUseListFromApi']),
    ...mapGetters('Common', ['getOftenUseScreenListFromState']),
    ...mapGetters('OftenUse', ['getCurrentOftenUseScreenIdsFromState']),
    ...mapActions('User', ['userNoticeRead']),
    ...mapGetters('User', ['getUnreadNoticeCount']),

    onClickSettting(item) {
      switch (item.name) {
        case 'contact':
          open('https://spe-s.jp/support/contact/', '_blank')
          return
        case 'tutorial':
          this.$router.push({ name: 'tutorial' }).catch(() => {})
          return
        default:
          break
      }

      this.settting.data[item.name].dialog = true
    },
    openNoticeDrawer() {
      this.userNoticeRead()
      this.notice.drawer = true
    },
    async execLogOut() {
      await this.logout()
    }
  },
  created() {
    Promise.all([
      this.getOftenUseListFromApi(),
      this.getOftenUseScreenListFromApi()
    ])
  },
  mounted() {
    this.setHasDisplayedAlertFlg({ hasDisplayed: false })
  }
}
